import { render } from "./PageInfo.vue?vue&type=template&id=14e52acc&scoped=true&lang=html"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"

import "./PageInfo.vue?vue&type=style&index=0&id=14e52acc&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e52acc"]])

export default __exports__